import { NavLink } from 'react-router-dom';
import { useState } from 'react';
import { useAuth } from '@/context/AuthContext';
import { ThemeToggle } from '@/components/ui/ThemeSelector';
import { ProfileModal } from '@/components/ProfileModal';

export function Header() {
  const { user } = useAuth();
  const [showProfileModal, setShowProfileModal] = useState(false);

  return (
    <>
      <header className="lg:hidden bg-bg-elevated shadow-theme-sm border-b border-subtle sticky top-0 z-40">
        <div className="flex items-center justify-between px-4 py-3">
          {/* Logo */}
          <NavLink to="/" className="flex items-center gap-2">
            <img
              src="https://dev.popkoorzzing.nl/wp-content/uploads/2023/06/Logo_ZZing_tr.png"
              alt="Zzing"
              className="h-8"
            />
            <span className="text-lg font-bold text-zzing-purple-500">Zzing</span>
          </NavLink>

          {/* Actions */}
          {user && (
            <div className="flex items-center gap-2">
              <ThemeToggle />
              <button
                onClick={() => setShowProfileModal(true)}
                className="w-9 h-9 rounded-full overflow-hidden bg-zzing-purple-500/20 flex items-center justify-center"
              >
                {user.photo ? (
                  <img src={user.photo} alt={user.name} className="w-full h-full object-cover" />
                ) : (
                  <span className="text-sm text-zzing-purple-500 font-semibold">
                    {user.name.charAt(0).toUpperCase()}
                  </span>
                )}
              </button>
            </div>
          )}
        </div>
      </header>

      <ProfileModal
        isOpen={showProfileModal}
        onClose={() => setShowProfileModal(false)}
      />
    </>
  );
}
